<template>
    <div class="col-md-12 mx-auto">
        <div class="loader" v-show="working"></div>
        <div v-show="!working" class="card mt-12">
            <div class="card-header bg-primary text-white">
                <page-title :title="$t(titleKey)"></page-title>
            </div>

            <div class="card-header" v-if="showSettingsBtn">
                <i class="fas fa-cogs pointer fa-2x float-right text-success"
                   v-if="showSettingsBtn"
                   @click.stop="changeGridSettings"
                   data-toggle="tooltip"
                   :title="settingsTooltipText"></i>

                <grid-user-settings :schemaModelFields="schemaModelFields"
                                    :componentName="componentName"
                                    v-if="showUserSettingsForm"
                                    @change="gridSettingsChanged">
                </grid-user-settings>
                <div style="clear: both;"></div>
                <div class="btn-toolbar justify-content-between mt-3" role="toolbar">
                    <div class="form-inline col-lg-6 col-md-12">
                        <button value="hasCreateRights" type="button" class="btn btn-primary" @click.stop="createBtnClick">
                            {{ $t('buttons.create.btnText') }}
                        </button>
                    </div>
                    <div class="input-group col-lg-6 col-md-12">
                        <input v-model="searchQuery" v-on:keyup.enter.stop="massSearch" v-on:keyup.esc.stop="clearFilters" type="text" class="form-control" aria-label="Mass search input" aria-describedby="massSearch">
                        <button class="btn btn-secondary" @click.stop="massSearch">
                            <i class="fas fa-search"></i>
                            {{ $t('buttons.search.btnText') }}
                        </button>
                        <button class="btn btn-secondary"
                                @click.stop="clearFilters">
                            <i class="fas fa-times"></i>
                            {{ $t('buttons.clearFilters.btnText') }}
                        </button>
                    </div>
                </div>

            </div>

            <div class="card-body">
                <kendo-datasource ref="datasource1"
                                  :transport="transportSettings"
                                  :schema-model-id="'id'"
                                  :schema-model-fields="schemaModelFields"
                                  :schema-total="'total'"
                                  :schema-data="'data'"
                                  :page-size='defaultGridRows'
                                  :server-paging="true"
                                  :server-sorting="true"
                                  :server-filtering="true"
                                  :error="dataSourceError"
                                  :requestEnd="datasorceRequestEnd">
                </kendo-datasource>
                <kendo-grid ref="citiesGrid"
                            id="citiesGrid"
                            data-source-ref="datasource1"
                            :editable="gridOptions.editable"
                            :filterable="gridOptions.filterable"
                            :pageable="gridOptions.pageable"
                            :reorderable="gridOptions.reorderable"
                            :resizable="gridOptions.resizable"
                            :groupable="gridOptions.groupable"
                            :allow-copy="gridOptions.allowCopy"
                            :column-menu="gridOptions.columnMenu"
                            :sortable-mode="gridOptions.sortable.mode"
                            :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                            :sortable-show-indexes="gridOptions.sortable.showIndexes"
                            :selectable="gridOptions.selectable"
                            :scrollable="gridOptions.scrollable"
                            :data-bound="dataBound">
                    <kendo-grid-column :field="'id'"
                                       :title="$t('registers.nomenclatures.gridHeaders.id')"
                                       v-html="rawHtml"
                                       :expandable="true"
                                       :lockable="true"
                                       :locked="false"
                                       :width="100">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'name'"
                                       :title="$t('registers.nomenclatures.gridHeaders.name')"
                                       :width="350"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'nameEn'"
                                       :title="$t('registers.nomenclatures.gridHeaders.nameEn')"
                                       :width="350"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'sort'"
                                       :title="$t('registers.nomenclatures.gridHeaders.sort')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'description'"
                                       :title="$t('registers.nomenclatures.gridHeaders.description')"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <!-- <kendo-grid-column :field="'deactivated'"
                                       :title="$t('registers.nomenclatures.gridHeaders.deactivated')"
                                       :width="120"
                                       :hidden="true"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :field="'active'"
                                       :title="$t('registers.nomenclatures.gridHeaders.active')"
                                       :template="activeCellTemplate"
                                       :width="120"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column> -->
                     <kendo-grid-column :title="$t('actions')"
                                       field="btnsColumn"
                                       :sortable="false"
                                       :filterable="false"
                                       :editable="false"
                                       :template="btnsTemplate"
                                       :width="150"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                    <kendo-grid-column :command="gridCommands"
                                       :width="200"
                                       :lockable="true"
                                       :locked="false">
                    </kendo-grid-column>
                </kendo-grid>
            </div>
        </div>
        <foreign-cities-grid v-model="showCreateModal" :foreign-cities-parent-id="foreignCitiesParentId" @cityCreated="onCityCreated"></foreign-cities-grid>

        <JsonFormatter v-model="dataReferences" :show.sync="showDataReferences"
                       :titleKey="'buttons.links.tooltipText'"
                       @onClose="onDataReferencesClose">
        </JsonFormatter>
    </div>
</template>

<script>
import Vue from 'vue';
import GridUserSettings from "@/components/grid/UserSettings";
import PageTitle from '@/components/common/PageTitle';
import ForeignCitiesGrid from '@/components/administration/nomenclature/foreignCity.create.modal';
import JsonFormatter from "@/components/common/json.formatter.modal.vue";
import BtnsTemplate from "@/components/grid/StandardBtnsTemplate";
import dataReferencesService from '@/services/dataReferences.service';
import citiesService from '@/services/city.service';

import { mapGetters } from 'vuex';

export default {
    components: {
        'grid-user-settings': GridUserSettings,
        PageTitle,
        ForeignCitiesGrid,
        JsonFormatter
    },
    props: {
        showResizeIcon: {
            default: false,
            type: Boolean
        },
        size: {
            default: 6,
            type: Number
        },
        showBtns: {
            default: true,
            type: Boolean
        },
        showSettingsBtn: {
            default: true,
            type: Boolean
        }
    },
    data() {
        return {
            componentName: "foreignCitiesEditor",
            titleKey: 'foreignCitiesEdit',
            foreignCitiesParentId: 0,
            rawHtml: "",
            detailsGridContextMenuFilter: ".k-detail-row tbody tr[role='row']",
            searchQuery: '',
            defaultGridRows: this.$store.getters.defaultGridRows,
            settingsTooltipText: this.$t('buttons.settings.tooltipText'),
            customSettingsLoaded: false,
            showCreateModal: false,
            schemaModelFields: {
                id: { name: 'id', type: 'number', editable: false, nullable: false, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.id', },
                name: { name: 'name', type: 'string', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.name', validation: { required: true } },
                nameEn: { name: 'nameEn', type: 'string', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.nameEn' },
                description: { name: 'description', type: 'string', editable: true, nullable: true, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.description' },
                sort: { name: 'sort', type: 'number', editable: true, nullable: false, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.sort' },
                active: { name: 'active', type: 'boolean', editable: false, nullable: false, visible: true, titleKey: 'registers.nomenclatures.gridHeaders.active', defaultValue: true },
                deactivated: { name: 'deactivated', type: 'boolean', editable: true, nullable: false, visible: false, titleKey: 'registers.nomenclatures.gridHeaders.deactivated', validation: { required: false }, defaultValue: false }
            },
            transportSettings: {
                read: {
                    url: this.$store.getters.baseUrl + '/api/cities/listForeignCities',
                    dataType: 'json',
                    type: 'POST',
                    contentType: 'application/json',
                    beforeSend: this.beforeSend
                },
                create: {
                    url: this.$store.getters.baseUrl + '/api/cities/create',
                    dataType: 'json',
                    type: 'POST',
                    contentType: 'application/json',
                    beforeSend: this.beforeSend
                },
                update: {
                    url: this.$store.getters.baseUrl + '/api/cities/update',
                    dataType: 'json',
                    type: 'POST',
                    contentType: 'application/json',
                    beforeSend: this.beforeSend
                },
                parameterMap: this.parameterMap
            },
            working: false,
            showUserSettingsForm: false,
            gridOptions: {
                ...this.$store.getters.gridOptions,
                editable: {
                    mode: 'popup',
                    window: {
                        title: "Номенклатура",
                        animation: true,
                        activate: this.editWindowActivate
                    }
                }
            },
            selectedRowsGrid: null,
            dataReferences: '',
            showDataReferences: false,
        };
    },
    methods: {
        async loadParentCitiesId() {
            const result = await this.$http.get('/api/cities/getForeignCitiesParentId');
            if (result) {
                this.foreignCitiesParentId = result.data;
            }
        },
        onCityCreated() {
            const ds = this.$refs.datasource1.kendoWidget();
            if (ds) {
                ds.read();
            }
        },
        createBtnClick() {
            this.showCreateModal = true;
        },
        dataBound(ev) {
            if (!this.customSettingsLoaded) {
                this.customSettingsLoaded = true;
                this.loadColumnsVisibilitySettings();
            }

            ev.sender.expandRow(ev.sender.tbody.find('tr.k-master-row').first())
        },
        parameterMap: function (options, operation) {
            if (operation !== 'read' && options.models) {
                return { models: kendo.stringify(options.models) }
            } else {
                // Викаме POST action за листване на номенклатурите и трябва да сериализираме
                // options. Така се предава информация за take, skip , page и списък с обекти
                // описващи сортирането
                return kendo.stringify(options);
            }
        },
        dataSourceError(e) {
            this.$vs.notify({
                title: this.$t('notifications.error'),
                text: this.$helpers.kendoDataSourceErrorText(e),
                color: 'danger',
                time: this.$store.getters.notificationDuration,
            })
        },
        activeCellTemplate: function (dataItem) {
            let templateHtml =
                '<span class="badge ' + (dataItem.active ? 'badge-success' : 'badge-danger') + '">' + kendo.htmlEncode(dataItem.active ? this.$t('yes') : this.$t('no')) + '</span>';

            return templateHtml;
        },
        beforeSend: function (req) {
            if (this.token) {
                req.setRequestHeader('Authorization', 'Bearer ' + this.token);
            }
        },
        changeGridSettings() {
            this.showUserSettingsForm = !this.showUserSettingsForm;
        },
        gridSettingsChanged(componentName, name, value) {
            this.setColumnVisibilitySettings();
        },
        loadColumnsVisibilitySettings() {
            return this.$http.get('/api/personalization/' + this.componentName + '/getColumnVisibility'
            ).then((response) => {
                // this.$vs.notify({
                //    title: '',
                //    text: this.$t('personalSettingsLoaded'),
                //    color: 'success',
                //    time: this.$store.getters.notificationDuration,
                // })

                if (response.data.settings === null) {
                    // Липсват запазени каквито и да е потребителски настройки. Осват тези по подразбиране
                    return;
                }

                let settings = [];
                for (var i = 0; i < response.data.settings.length; i++) {
                    settings.push(response.data.settings[i].name)
                }

                for (const key in this.schemaModelFields) {
                    if (this.schemaModelFields.hasOwnProperty(key)
                        && this.schemaModelFields[key].hasOwnProperty('visible')) {
                        this.schemaModelFields[key].visible = settings.includes(key);
                    }
                }

                this.setColumnVisibilitySettings();
            }).catch(error => {
                this.$vs.notify({
                    title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                    text: this.$helpers.errorText(error),
                    color: 'danger',
                    time: this.$store.getters.notificationDuration
                })
            })
        },
        setColumnVisibilitySettings() {
            var grid = this.$refs.citiesGrid.kendoWidget();
            var columns = grid.columns;

            // restore columns visibility state using the stored values
            for (var i = 0; i < columns.length; i++) {
                var column = columns[i];
                if (!column.field
                    || !this.schemaModelFields.hasOwnProperty(column.field)
                    || !this.schemaModelFields[column.field].hasOwnProperty('visible')) {
                    continue;
                }

                if (this.schemaModelFields[column.field].visible) {
                    grid.showColumn(column);
                } else {
                    grid.hideColumn(column);
                }
            }
        },
        datasorceRequestEnd(e) {
            if (e.type === "create" && e.response) {
                e.sender.read()

                let statusCode = this.$helpers.errorStatusCode(e);
                this.$vs.notify({
                    title: this.$t('request.response.status.' + statusCode),
                    text: this.$helpers.errorText(e.response),
                    color: statusCode === 200 ? 'success' : 'danger',
                    time: this.$store.getters.notificationDuration
                })
            } else if (e.type === "update" && e.response) {
                e.sender.read()

                let statusCode = this.$helpers.errorStatusCode(e);
                this.$vs.notify({
                    title: this.$t('request.response.status.' + statusCode),
                    text: this.$helpers.errorText(e.response),
                    color: statusCode === 200 ? 'success' : 'danger',
                    time: this.$store.getters.notificationDuration
                })
            }
        },
        editWindowActivate(e) {},
        clearFilters() {
            this.searchQuery = '';
            const grid = this.$refs.citiesGrid.kendoWidget();
            if (grid) {
                grid.dataSource.sort({});
                grid.dataSource.page(1);
                grid.dataSource.aggregate([]);
                grid.dataSource.filter({});
            }
        },
        massSearch() {
            if (!this.searchQuery) {
                this.$vs.notify({
                    title: this.$t('buttons.search.btnText'),
                    text: this.$t('emptySearchFilter'),
                    color: 'warning',
                    time: this.$store.getters.notificationDuration
                })

                return;
            }

            let grid = this.$refs.citiesGrid.kendoWidget();
            if (grid) {
                let filter = this.$helpers.getMassFilterForGrid(grid, this.searchQuery);
                if (filter) {
                    grid.dataSource.filter(filter);
                }
            }
        },
        deactivateBtnClick(args) {
            if (!this.hasDeleteRights) {
                return this.$router.push(`/unauthorized`);
            }

            if (!args.active) {
                this.$vs.notify({
                    title: this.$t('buttons.deactivate.action'),
                    text: this.$t('buttons.deactivate.already'),
                    color: 'warning',
                    time: this.$store.getters.notificationDuration,
                })

                return;
            }

            this.working = true;

            citiesService
                .deactivate(args.id)
                .then(response => {
                    this.working = false;
                    this.refreshGrid();

                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration
                    });
                })
                .catch(error => {
                    this.working = false;

                    this.$vs.notify({
                        title: this.$t('buttons.deactivate.action'),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration
                    })
                });
        },
        activateBtnClick(args) {
            if (!this.hasDeleteRights) {
                return this.$router.push(`/unauthorized`);
            }

            if (args.active) {
                this.$vs.notify({
                    title: this.$t('buttons.activate.action'),
                    text: this.$t('buttons.activate.already'),
                    color: 'warning',
                    time: this.$store.getters.notificationDuration,
                })

                return;
            }

            this.working = true;

            citiesService
                .activate(args.id)
                .then(response => {
                    this.working = false;
                    this.refreshGrid();

                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: this.$helpers.responseMessage(response),
                        color: 'success',
                        time: this.$store.getters.notificationDuration
                    });
                })
                .catch(error => {
                    this.working = false;

                    this.$vs.notify({
                        title: this.$t('buttons.activate.action'),
                        text: this.$helpers.errorText(error),
                        color: this.$helpers.errorColor(error),
                        time: this.$store.getters.notificationDuration
                    })
                });
        },
        beforeExcelExport(e) {
            e.preventDefault();

            this.massEditSelected(e);
        },
        onSelectedRowsEdit(grid) {
            if (grid) {
                grid.dataSource.read();
            }

            this.selectedRowsGrid = null;
        },
        dataReferencesBtnClick(dataItem) {
            if (!this.claims.dataReferences.read) {
                return this.$router.push(`/unauthorized`);
            }

            if (!dataItem) {
                return;
            }

            return this.getDataReferences(dataItem.id);
        },
        getDataReferences(id) {
            dataReferencesService
                .checkReferences('N', 'Cities', id, this.dataReferencesListCount, true)
                .then(response => {
                    if (response.data) {
                        this.dataReferences = response.data;
                    }

                    this.showDataReferences = true;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        onDataReferencesClose() {
            this.dataReferences = '';
            this.showDataReferences = false
        },
        refreshGrid() {
            const grid = this.$refs.citiesGrid.kendoWidget();
            if (grid) {
                grid.dataSource.read();
            }
        },
        dataReferencesReplaceCommandClick(args) {
            if (!this.claims.dataReferences.update) {
                return this.$router.push(`/unauthorized`);
            }

            if (!args) {
                return;
            }

            kendo.prompt(`${this.$t('dataReference.replacePrompt')}`, '')
                .then(function (data) {
                    const replacementId = Number(data);
                    if (isNaN(replacementId)) {
                        this.$vs.notify({
                                title: this.$t('notifications.error'),
                                text: 'replacementId is not a number',
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });
                        return;
                    }

                    const model = {
                        schemaName: 'Registers',
                        tableName: 'Institution',
                        replacedId: args.id,
                        replacementId: replacementId
                    }

                    this.working = true;

                    dataReferencesService.replaceReferences(model)
                        .then(response => {
                            this.$vs.notify({
                                title: this.$t('buttons.replace.btnText'),
                                text: this.$helpers.responseMessage(response),
                                color: 'success',
                                time: this.$store.getters.notificationDuration
                            });
                        })
                        .catch(error => {
                            this.$vs.notify({
                                title: this.$t('buttons.replace.btnText'),
                                text: this.$helpers.errorText(error),
                                color: 'danger',
                                time: this.$store.getters.notificationDuration
                            });
                        })
                        .then(() => {
                            this.working = false;
                        });
                }.bind(this));
        },
        btnsTemplate: function (e) {
            return {
                template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                templateArgs: {
                    ...e,
                    parentComponent: this.$refs.citiesGrid,
                    btns:
                        [
                            // {
                            //     name: "deactivation",
                            //     text: "",
                            //     tooltip: this.$t('buttons.deactivate.btnText'),
                            //     class: 'btn btn-danger',
                            //     icon: "fas fa-lock",
                            //     show: this.hasDeleteRights && e.active,
                            //     clickHandler: this.deactivateBtnClick
                            // }, {
                            //     name: 'activation',
                            //     text: "",
                            //     tooltip: this.$t('buttons.activate.btnText'),
                            //     class: 'btn btn-success',
                            //     icon: "fas fa-lock-open",
                            //     show: this.hasDeleteRights && !e.active,
                            //     clickHandler: this.activateBtnClick
                            // },
                            {
                                name: 'dataReferences',
                                text: "",
                                tooltip: this.$t('buttons.links.tooltipText'),
                                class: 'btn btn-info',
                                icon: "fas fa-link",
                                show: this.claims.dataReferences.read,
                                clickHandler: this.dataReferencesBtnClick
                            },
                            {
                                name: 'referencesReplace',
                                text: '',
                                tooltip: this.$t('buttons.replace.btnText'),
                                class: 'btn btn-info',
                                icon: 'fas fa-sync',
                                show: this.claims.dataReferences.update,
                                clickHandler: this.dataReferencesReplaceCommandClick
                            },
                        ]

                }
            };
        },
    },
    computed: {
        ...mapGetters(['isEnVersion', 'claims', 'dataReferencesListCount']),
        token: function () {
            return this.$store.getters.authToken;
        },
        gridCommands: function () {
            const commands = []
            if (this.hasUpdateRights) {
                commands.push({ name: 'edit', text: this.$t('buttons.edit.btnText') });
            }

            return commands;
        },
        hasReadRights() {
            return this.claims.nomenclature.read;
        },
        hasCreateRights() {
            return this.claims.nomenclature.create;
        },
        hasUpdateRights() {
            return this.claims.nomenclature.update;
        },
        hasDeleteRights() {
            return this.claims.nomenclature.delete;
        }
    },
    mounted() {
        this.loadParentCitiesId();
    }
}
</script>
